
import { isOccasion } from './serviceUtil';

export const getOverrideClass = (service, fieldName) => {
    return (isOccasion(service) && service.override_fields[fieldName]) ? 'p--red' : '';
};



// WEBPACK FOOTER //
// ./src/helpers/autofillOverride.js